import React from 'react'
import List from '../../../../components/lists/list.component.jsx'
import Title from './../../../../components/typography/title.component'
import banner from '../../../../../assets/images/banners-amigos/banner.png'
import bannerMobile from '../../../../../assets/images/banners-amigos/banner-mobile.png'
import Button from '../../../../components/buttons/buttons.component'
import styled from 'styled-components'
import Container from '../../../../components/layout/container.component'
import copyToClipboard from '../../../../helpers/clipboard.helper'
import StyledFlexContainer from '../../../../components/containers/flex-container.component.jsx'
import { GRAY, PRIMARY_COLOR } from '../../../../styles/colors.style'
import { connect } from 'react-redux'
import { TextInput } from '../../../../components/form-components/inputs.component.jsx'
import { withRouter } from 'react-router-dom'
import { Form, Formik } from 'formik'
import { toastActions } from '../../../../actions'
import { bindActionCreators } from 'redux'
import { FriendInviteService } from '../../../../services'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { isMobile } from '../../../../helpers'

const StyledText = styled.div`
	color: ${GRAY};
	font-size: 15px;
	margin-top: 3rem;
	text-align: center;
`

const StyledTitle = styled.div`
	color: ${PRIMARY_COLOR};
	font-size: 3rem;
	margin-top: 3rem;
	text-align: center;
`

const StyledBanner = styled.img`
	margin-bottom: 25px;
	margin-top: 25px;
	width: 100%;
`

const containerStyle = { paddingBottom: '25px' }

class InviteYourPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			friendList: [],
		}

		this.copyToClipboard = () =>
			copyToClipboard(this.refs.form.state.values.inviteLink)
	}

	componentDidMount() {
		FriendInviteService.list().then(({ success, data }) => {
			const friendList = success
				? data.map(({ friendName }) => friendName)
				: []
			this.setState({ friendList })
		})
		FriendInviteService.getLink().then((inviteLink) =>
			this.refs.form.setValues({
				inviteLink,
			})
		)
	}

	render() {
		const showPage = false
		if (showPage) {
			return (
				<Container style={containerStyle}>
					<Title>Convide seus amigos</Title>
					<StyledBanner
						src={isMobile() ? bannerMobile : banner}
						alt="Banner indique amigos e ganhe pontos"
					/>

					<Formik
						initialValues={{ inviteLink: '' }}
						ref={'form'}
						render={(props) => (
							<Form noValidate>
								<StyledFlexContainer marginTop={1}>
									<div className={'col-4 filler'} />
									<TextInput
										className={'col-4'}
										disabled
										id="inviteLink"
										label="Copie e compartilhe o link abaixo com os seus amigos"
										autoFocus={true}
										{...props}
									/>
									<div className={'col-3'}>
										<Button
											primary
											type={'button'}
											onClick={this.copyToClipboard}>
											Copiar
										</Button>
									</div>
								</StyledFlexContainer>
								<StyledText>
									Você poderá convidar quantos amigos quiser.
									<br />
									Porém, você receberá pontos bônus apenas para os
									primeiros 10 amigos que confirmarem o cadastro no
									Muviflex.
									<br />
									Lembre-se: Só serão válidos os cadastros realizados
									através do link exclusivo enviado.
								</StyledText>
								{this.state.friendList.length == 0 ? (
									<StyledTitle>
										Convide seus amigos para fazer parte do Muviflex!
									</StyledTitle>
								) : (
									<List
										title={
											'Amigos que você convidou e já se cadastraram:'
										}
										items={this.state.friendList}
									/>
								)}
							</Form>
						)}
					/>
				</Container>
			)
		}
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
		},
		dispatch
	)

const connectedInviteYourPageComponent = withRouter(
	connect(null, mapDispatchToProps)(InviteYourPageComponent)
)

export { connectedInviteYourPageComponent as ModuleRootComponent }
